import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Container,
  Box,
  Typography,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress
} from '@mui/material';
import { policyClaimsAPI } from '../services/api';
import ClaimStatusBadge from '../components/Claims/ClaimStatusBadge';

const formatDate = (d) => d ? new Date(d).toLocaleDateString() : '—';
const formatCurrency = (n) => n != null ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(n) : '—';

export default function ClaimHistory() {
  const { id: policyId } = useParams();
  const navigate = useNavigate();
  const [claims, setClaims] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!policyId) return;
    (async () => {
      try {
        const list = await policyClaimsAPI.list(policyId);
        setClaims(Array.isArray(list) ? list : []);
      } catch (e) {
        console.warn(e);
        setClaims([]);
      } finally {
        setLoading(false);
      }
    })();
  }, [policyId]);

  return (
    <Container maxWidth="md" sx={{ py: 3 }}>
      <Typography variant="h5" fontWeight="bold" sx={{ mb: 2 }}>Claims for this policy</Typography>
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}><CircularProgress /></Box>
      ) : claims.length === 0 ? (
        <Typography color="textSecondary">No claims for this policy.</Typography>
      ) : (
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Claim #</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Amount</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Service date</TableCell>
                <TableCell align="right">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {claims.map((c) => (
                <TableRow key={c.id}>
                  <TableCell>{c.claim_number}</TableCell>
                  <TableCell>{c.claim_type}</TableCell>
                  <TableCell>{formatCurrency(c.claimed_amount)}</TableCell>
                  <TableCell><ClaimStatusBadge status={c.status} /></TableCell>
                  <TableCell>{formatDate(c.service_date)}</TableCell>
                  <TableCell align="right">
                    <Button size="small" onClick={() => navigate(`/claims/${c.id}`)}>View</Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      <Button sx={{ mt: 2 }} onClick={() => navigate(`/wallet/policy/${policyId}`)}>Back to policy</Button>
    </Container>
  );
}
